import React, { useContext, useEffect, useRef, useState } from "react";
import UserContext from "../../components/context/UserContext";
import BookingCalendar from "./BookingCalendar";
import { FaRegCalendarAlt, FaSearch } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import * as apicall from "../../components/Apicall";
import RotateDevicePopup from "../../components/RotateDevicePopup/RotateDevicePopup";
import { MultiSelect } from "primereact/multiselect";
import { LuClipboardCheck, LuClock } from "react-icons/lu";
import { HiOutlineUsers } from "react-icons/hi2";

const NewDashboard1 = () => {
  const [initialData, setInitialData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const { vendor, refreshVendorData } = useContext(UserContext);
  const flagCount = useRef(0);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [orderCounts, setOrderCounts] = useState({
    total: 0,
    completed: 0,
    progress: 0,
    cancelled: 0,
  });
  const [selectedProvider, setSelectedProvider] = useState([]);
  const [loading, setLoading] = useState(false);
  const lastRequestId = useRef(0);
  const [search, setSearch] = useState("");

  // console.log("selectedDate----", selectedDate);

  useEffect(() => {
    let today = new Date();
    let d1 = today.toLocaleDateString("en-GB").split(/[\/\-\.]/);
    // console.log("d1---", d1);
    let d2 = `${d1[2]}-${d1[1]}-${d1[0]}`;
    // console.log("d2--", d2);
    setSelectedDate(d2);
    getBookingByDate();
    refreshVendorData();
  }, []);

  useEffect(() => {
    getBookingByDate();
  }, [selectedDate]);

  const getBookingByDate = async () => {
    try {
      // console.log("selectedDate--", selectedDate);
      if (!selectedDate) return;
      setLoading(true);
      let currentId = ++lastRequestId.current;
      const get_booking_data = await apicall.get(
        `get_ezp_booking?date=${selectedDate}`
      );

      if (currentId !== lastRequestId.current) return;

      // console.log("get_booking_data-----", get_booking_data);
      let allData = get_booking_data?.data;
      let a1 = allData.filter((ele) => ele?.booking_status !== "Cancelled");
      console.log("a1---", a1);
      setFullData(a1);
      setInitialData(a1);
      const counts = {
        total: allData?.length,
        progress: allData?.filter(
          (item) => item.booking_status === "In Progress"
        ).length,
        completed: allData?.filter(
          (item) => item.booking_status === "Completed"
        ).length,
        cancelled: allData?.filter(
          (item) => item.booking_status === "Cancelled"
        ).length,
      };
      setOrderCounts(counts);
      setLoading(false);
    } catch (e) {
      console.log("err----", e);
    }
  };

  const getStatusColors = (status) => {
    // Define color schemes for different statuses with requested light colors
    const statusColors = {
      // Pending/Upcoming (10) - Light yellow
      10: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },

      // Completed/Checked Out (15) - Light green
      1: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },

      // Checked In (11) - Light blue
      2: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled (14) - Light red
      3: {
        bgColor: "rgba(255, 204, 204, 0.5)",
        borderColor: "#CC0000",
        textColor: "#990000",
      },
      4: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },
      // No Show (15) - Light orange
      12: {
        bgColor: "F2F9FF",
        borderColor: "#037FE8",
        textColor: "#037FE8",
      },

      // Default - Light gray
      default: {
        bgColor: "rgba(230, 230, 230, 0.5)",
        borderColor: "#999999",
        textColor: "#666666",
      },
    };

    return statusColors[status] || statusColors.default;
  };

  const getStatusName = (status) => {
    const statusColors = {
      4: "Completed",
      2: "In Progress",
      3: "Cancelled",
      default: "In Progress",
    };

    return statusColors[status] || statusColors.default;
  };

  const toFullCalendarDate = (bookingDate, bookingTime) => {
    return `${bookingDate}T${bookingTime}:00`; // Assuming bookingTime is in 'HH:mm' format
  };

  const addMinutes = (timeStr, minutesToAdd) => {
    const [hours, minutes] = timeStr?.split(":")?.map(Number);
    const date = new Date();
    date.setHours(hours, minutes + minutesToAdd, 0, 0);
    return date.toTimeString().slice(0, 5); // "HH:mm"
  };

  const calenderData = fullData?.flatMap((item) => {
    const colors = getStatusColors(item?.status);

    const start = toFullCalendarDate(item.service_date, item.service_time);

    const providerList = item.provider_names
      ? item.provider_names.split(",").map((p) => p.trim())
      : [];

    const timePerPerson =
      (Number(item?.total_time_required) + Number(item?.total_buffer)) /
      (providerList.length || 1);

    const endTime = addMinutes(item?.service_time, timePerPerson);
    const end = toFullCalendarDate(item.service_date, endTime);

    item.status_name = getStatusName(item.status);

    //  CREATE ONE EVENT PER PERSON
    return providerList.map((provider) => ({
      title: provider, //  single name
      resourceId: provider, //  single resource
      start,
      end,
      backgroundColor: colors.bgColor,
      borderColor: colors.borderColor,
      textColor: colors.textColor,
      extendedProps: {
        ...item,
        provider_name: provider, //  add explicitly
      },
      className: `status-${item?.status || "default"}`,
    }));
  });

  const result = calenderData.reduce(
    (acc, item) => {
      return {
        minStart: item.start < acc.minStart ? item.start : acc.minStart,
        maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
      };
    },
    {
      minStart: calenderData[0]?.start,
      maxEnd: calenderData[0]?.end,
    }
  );

  let min1 = result?.minStart?.split("T")[1];
  let max1 = result?.maxEnd?.split("T")[1];

  let minTime = "08:00:00";
  min1 = min1 < minTime ? min1 : "08:00:00";

  let maxTime = "20:00:00";
  max1 = max1 > maxTime ? max1 : "20:00:00";

  const handleAppointmentClick = (data, currentDate) => {
    // console.log("data, currentDate--", data, currentDate);
    let group_id = data?.details?.display_booking_id || 1;
    // console.log("display_booking_id---", data?.details?.display_booking_id);
    navigate(`/vendor_bookings/${group_id}`);
    // fetchDoctorAvailability(data?.details?.doctor_id, currentDate);
    // fetchDoctorHolidays(data?.details?.doctor_id);
  };

  const datesSet = (dateInfo) => {
    try {
      console.log("flag.current-----", dateInfo, flagCount.current);

      // console.log("adteIfo---", dateInfo);
      let d1 = dateInfo.startStr?.split("T")?.[0];
      console.log("d1-----", d1);
      setSelectedDate(d1);

      if (![0, 1].includes(flagCount.current)) {
        // console.log("adteIfo---", dateInfo);
        let d1 = dateInfo.startStr?.split("T")?.[0];
        // console.log("d1-----", d1);
        setSelectedDate(d1);
        // setDateSelect(d1);
        // getWorkerAvailableSlots(d1);
      }
      flagCount.current += 1;
    } catch (e) {
      console.log("err---", e);
    }
  };

  const formatDateDisplay = (date) => {
    if (!date) return "";

    const d = new Date(date);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return `${
      months[d.getUTCMonth()]
    } ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
  };

  const detailedDashBoard = () => {
    // console.log("detailedDashBoard");
    navigate(`/dashboard/${selectedDate}`);
  };

  // const allProvider = [
  //   ...new Map(
  //     initialData?.map((item) => [
  //       item.provider_names,
  //       { name: item.provider_names },
  //     ])
  //   ).values(),
  // ];

  const allProvider = [
    ...new Set(
      initialData?.flatMap((item) =>
        item.provider_names?.split(",").map((name) => name.trim())
      )
    ),
  ]
    .sort()
    .map((ele) => {
      return { name: ele };
    });

  // console.log("allProvider---", allProvider);
  const [dates, setDates] = useState([]);

  const stripRef = useRef(null);
  const activeDateRef = useRef(null);
  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Initial window: 30 days past + 30 days future
    const initialDates = [];
    for (let i = -30; i <= 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      initialDates.push(date);
    }
    setDates(initialDates);
  }, []);
  useEffect(() => {
    if (activeDateRef.current) {
      activeDateRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [selectedDate, dates]);
  // load more past dates when user scrolls left
  const handleScroll = () => {
    if (!stripRef.current) return;

    // if scroll is near left edge
    if (stripRef.current.scrollLeft < 50) {
      const firstDate = dates[0];
      const newPastDates = [];
      for (let i = 1; i <= 30; i++) {
        const date = new Date(firstDate);
        date.setDate(firstDate.getDate() - i);
        newPastDates.unshift(date);
      }
      setDates((prev) => [...newPastDates, ...prev]);

      // maintain scroll position after prepending
      stripRef.current.scrollLeft += 30 * 60; // approximate width of 30 date boxes
    }
  };
  const onProviderSearch = (providers) => {
    setSelectedProvider(providers);

    if (!providers.length) {
      setFullData(initialData);
      return;
    }

    const names = providers.map((p) => p.name);

    const filtered = initialData.filter((item) => {
      if (item.provider_names?.includes(",")) {
        let p1 = item.provider_names.split(",");
        for (let i of p1) {
          if (names.includes(i.trim())) {
            return true;
          }
        }
      } else {
        return names.includes(item.provider_names);
      }
    });

    setFullData(filtered);
  };

  return (
    <>
      <RotateDevicePopup />
      <div className="row">
        <div className="col-12">
          {/* ================= OVERVIEW HEADER ================= */}
          <div className="d-flex justify-content-between align-items-center mb-3 pt-0">
            <div>
              <h5
                className="mb-0"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                Overview
                {selectedDate && (
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      marginLeft: "8px",
                      color: "#6C757D",
                    }}
                  >
                    ({formatDateDisplay(selectedDate)})
                  </span>
                )}
              </h5>
            </div>

            <div
              className="d-flex align-items-center gap-2"
              style={{ position: "relative" }}
            >
              <span style={{ fontSize: "14px", color: "#000" }}>
                Filter by:
              </span>

              <div style={{ position: "relative" }}>
                <button
                  className="btn btn-light d-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                    padding: 0,
                    border: "1px solid #E3EBF8",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpen(!open);
                  }}
                >
                  <FaRegCalendarAlt size={14} />
                </button>

                {open && (
                  <div
                    style={{
                      position: "absolute",
                      top: "40px",
                      right: 0,
                      zIndex: 9999,
                    }}
                  >
                    <DatePicker
                      selected={selectedDate ? new Date(selectedDate) : null}
                      onChange={(date) => setSelectedDate(date)}
                      inline
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ================= SEARCH + NEW BOOKING (DESKTOP ONLY) ================= */}
          <div className="desktop-only d-flex justify-content-between align-items-center">
            <div className="d-flex gap-3 align-items-center">
              <div className="position-relative">
                {/* <input
                  type="text"
                  value={search}
                  className="form-control"
                  placeholder="Search"
                  onChange={(e) => onProviderSearch(e.target.value)}
                  style={{
                    height: "40px",
                    width: "240px",
                    backgroundColor: "#F8F9FA",
                    border: "1px solid #E3EBF8",
                    borderRadius: "8px",
                    paddingLeft: "36px",
                    fontSize: "14px",
                  }}
                />
                <FaSearch
                  className="position-absolute text-muted"
                  style={{ left: "12px", top: "12px" }}
                /> */}
                <div style={{ width: "240px" }}>
                  <MultiSelect
                    value={selectedProvider}
                    onChange={(e) => onProviderSearch(e.value)}
                    options={allProvider}
                    optionLabel="name"
                    filter
                    placeholder="Search Crew"
                    maxSelectedLabels={2}
                    style={{
                      width: "100%",
                      height: "40px",
                      backgroundColor: "#F8F9FA",
                      border: "1px solid #E3EBF8",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>
            </div>

            <div>
              <div
                onClick={() => navigate("/vendor_bookings")}
                className="btn-danger rounded p-2 px-3 cursor-pointer"
              >
                New Booking
              </div>
            </div>
          </div>

          {/* ================= OVERVIEW TILES ================= */}
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 mb-4 mt-2">
            {[
              {
                label: "Total",
                icon: (
                  <LuClock style={{ fontSize: "20px", color: "#037FE8" }} />
                ),
                value: orderCounts?.total,
                color: "#037FE8",
              },
              {
                label: "Completed",
                icon: (
                  <LuClipboardCheck
                    style={{ fontSize: "20px", color: "#CCCC00" }}
                  />
                ),
                value: orderCounts?.completed,
                color: "#CCCC00",
              },
              {
                label: "In Progress",
                icon: (
                  <HiOutlineUsers
                    style={{ fontSize: "20px", color: "#92007E" }}
                  />
                ),
                value: orderCounts?.progress,
                color: "#92007E",
              },
              {
                label: "Cancelled",
                icon: (
                  <HiOutlineUsers
                    style={{ fontSize: "20px", color: "#FF0000" }}
                  />
                ),
                value: orderCounts?.cancelled,
                color: "#FF0000",
              },
            ].map((item, index) => (
              <div
                className="col"
                onClick={() => detailedDashBoard()}
                key={index}
              >
                <div
                  className="card d-flex flex-row align-items-center p-3"
                  style={{
                    cursor: "pointer",
                    borderRadius: "12px",
                    height: "90px",
                    border: "1px solid #E3EBF8",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: item.bgColor,
                      borderRadius: "50%",
                      width: "48px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                    }}
                  >
                    {item.icon}
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: `${item?.color}`,
                        marginBottom: "4px",
                      }}
                    >
                      {item.label}
                    </div>
                    <h5
                      style={{
                        color: `${item?.color}`,
                        fontSize: "18px",
                        fontWeight: "700",
                        margin: 0,
                      }}
                    >
                      {item.value}
                    </h5>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ================= MOBILE TODAY SCHEDULE ================= */}
          <div className="mobile-only-section">
            <h5 style={{ fontSize: "16px", fontWeight: "600" }}>
              Today's Schedule
            </h5>

            {/* Search */}
            <div className="position-relative mt-3">
              <FaSearch className="mobile-search-icon" />
              <input
                type="text"
                className="form-control mobile-search"
                placeholder="Search"
                value={search}
                onChange={(e) => onProviderSearch(e.target.value)}
              />
            </div>

            {/* Horizontal Dates */}
            {/* Horizontal Dates */}
            <div
              className="mobile-date-strip"
              ref={stripRef}
              onScroll={handleScroll}
            >
              {dates.map((date, index) => {
                const formatted = date.toLocaleDateString("en-CA");
                const isActive = formatted === selectedDate;

                return (
                  <div
                    key={index}
                    ref={isActive ? activeDateRef : null}
                    className={`mobile-date-box ${isActive ? "active" : ""}`}
                    onClick={() => setSelectedDate(formatted)}
                  >
                    <div>{date.getDate()}</div>
                    <small>
                      {date.toLocaleString("en-US", { month: "short" })}
                    </small>
                  </div>
                );
              })}
            </div>

            {/* Booking List */}
            {calenderData?.length === 0 && (
              <div className="text-center text-muted mt-3">
                No Appointments for this day
              </div>
            )}

            {calenderData?.map((event, index) => {
              const start = new Date(event.start);
              const end = new Date(event.end);

              const formatTime = (date) =>
                date.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });

              const statusName = event.extendedProps?.status_name;
              const status = event.extendedProps?.status;

              const colors = getStatusColors(status);

              <div className="text-muted small text-end">
                <div>
                  {formatTime(start)} - {formatTime(end)}
                </div>

                {event.extendedProps?.display_booking_id && (
                  <div>
                    Booking ID: {event.extendedProps.display_booking_id}
                  </div>
                )}

                {event.extendedProps?.phone_number && (
                  <div>Phone: {event.extendedProps.phone_number}</div>
                )}
              </div>;
              return (
                <div
                  key={index}
                  className="mobile-booking-card"
                  onClick={() =>
                    handleAppointmentClick(
                      { details: event.extendedProps },
                      selectedDate
                    )
                  }
                >
                  <div className="d-flex justify-content-between align-items-start">
                    {/* Left Section */}
                    <div>
                      <div className="fw-semibold">
                        {Array.isArray(event.extendedProps?.providers)
                          ? event.extendedProps.providers.join(", ")
                          : event.extendedProps?.provider_name || event.title}
                      </div>

                      {event.extendedProps?.partner_name && (
                        <div className="text-muted small">
                          {event.extendedProps.partner_name}
                        </div>
                      )}

                      {statusName && (
                        <span
                          className="mobile-status"
                          style={{
                            backgroundColor: colors.bgColor,
                            color: colors.textColor,
                            border: `1px solid ${colors.borderColor}`,
                          }}
                        >
                          {statusName}
                        </span>
                      )}
                    </div>

                    {/* Right Section */}
                    <div className="text-end">
                      <div className="fw-semibold small">
                        {formatTime(start)} - {formatTime(end)}
                      </div>

                      {event.extendedProps?.user_name && (
                        <div className="small">
                          {event.extendedProps.user_name}
                        </div>
                      )}

                      {event.extendedProps?.phone_number && (
                        <div className="small text-muted">
                          {event.extendedProps.phone_number}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* ================= DESKTOP CALENDAR ================= */}
          <div className="calendar-wrapper">
            <div className="card border-0">
              <div className="card-body p-34 border-box">
                <div
                  className="position-relative removeHeader dashboardCalender"
                  style={{ minHeight: "720px" }}
                >
                  <BookingCalendar
                    closeCalendarFUN={() => console.log("Close...")}
                    events={calenderData}
                    date={selectedDate}
                    datesSet={datesSet}
                    onAppointmentClick={handleAppointmentClick}
                    scrollToEventId="event-1"
                    startTime={min1}
                    endTime={max1}
                    headerToolbar={true}
                    copy={true}
                    height="max-content"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewDashboard1;
